<h4 mat-dialog-title>{{ data.title }} </h4>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onConfirm()">{{ 'LABEL.OK' | translate }}</button>
</div>